import { boxLinkStyles } from '@/components/Atoms/BoxLink/BoxLink';
import styled from 'styled-components';

/**
 * This component defines a styled anchor that can be used in titles and highlighted sections.
 */
export const TitleLink = styled.a<{ $asBoxLink?: boolean }>`
    display: block;
    text-decoration: none;
    &:visited {
        color: var(--color-body-linkVisitedOption);
    }
    ${({ $asBoxLink }) => $asBoxLink && boxLinkStyles};
`;
